  <!-- <footer id="footer">
    <div class="container">
      <h3>GCHC</h3>
      <p>gerencia.</p>
      <div class="social-links">
        <a href="#" class="twitter"><i class="bx bxl-twitter"></i></a>
        <a href="#" class="facebook"><i class="bx bxl-facebook"></i></a>
        <a href="#" class="instagram"><i class="bx bxl-instagram"></i></a>
        <a href="#" class="google-plus"><i class="bx bxl-skype"></i></a>
        <a href="#" class="linkedin"><i class="bx bxl-linkedin"></i></a>
      </div>
      <div class="copyright">
        &copy; Copyright <strong><span>Centro Histórico del Cusco</span></strong>. All Rights Reserved
      </div>
      <div class="credits">
        Designed by <a href="https://bootstrapmade.com/">IOARR</a>
      </div>
    </div>

  </footer>  -->


  <footer class="footer-wrapper">
    <!-- Start Footer Widget Area -->
    <div class="footer-widget-wrapper pt-40 pt-md-80 pt-sm-60 pb-60 pb-md-78 pb-sm-60" style="background-image: url('/assets/img/fondo-footer.png'); background-size: cover;
    background-position: center;">
        <div class="container" >
            <div class="row">
              <div class="col-md-4 text-center mb-40">
                <img src="/assets/img/muni.png" width="100">
              </div>
              <div class="col-md-4 text-center mb-40">
                <img src="/assets/img/logo-gerencia.png" width="100">
              </div>
              <div class="col-md-4 text-center mb-40">
                <img src="/assets/img/slogan.png" width="80">
              </div>
            </div>
            <div class="row mtm-44">
                <div class="col-lg-3 col-md-6">
                    <div class="single-widget-wrap">
                        <h3 class="widget-title">Dirección</h3>
                        <div class="widget-body">
                            <div class="about-text">
                                <address><i class="fa fa-map-marker" style="color:#FDC657"></i> Calle Pumakurko 470<br>Cusco - Perú</address>
                                <!-- <a href="#"><i class="fa fa-envelope" style="color:#FDC657"></i> saby.zarate@cusco.gob.pe</a><br> -->
                                <a href="#"><i class="fa fa-envelope" style="color:#FDC657"></i> centro.historico@cusco.gob.pe</a><br>
                                <a href="http://catalogacion.cusco.gob.pe/"><i class="fa fa-globe" style="color:#FDC657"></i> catalogacion.cusco.gob.pe</a>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="col-lg-3 col-md-6">
                    <div class="single-widget-wrap">
                        <h3 class="widget-title">Horario de atención</h3>
                        <div class="widget-body">
                            <div class="latest-blog-widget">
                                <div class="single-blog-item">
                                    <h3><a href="#">Lunes a viernes</a></h3>
                                    <span class="post-date"><i class="fa fa-clock-o"></i> 8:00 am - 1:00 pm</span>
                                    <h3 style="margin-top: 10px;"><a href="#">Teléfonos</a></h3>
                                    <span class="post-date"><i class="fa fa-phone"></i> 986428724</span><br>
                                    <!-- <span class="post-date"><i class="fa fa-phone"></i> +51 984 682425</span> -->
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-lg-3 col-md-6">
                    <div class="single-widget-wrap">
                        <h3 class="widget-title">Links importantes</h3>
                        <div class="widget-body">
                            <ul class="widget-list">
                                <li><a href="/catalogacion">Catalogación</a></li>
                                <li><a href="/inmaterial">Patrimonio Inmaterial</a></li>
                                <li><a href="/planmaestro">Plan Maestro</a></li>
                                <li><a href="/requisitos">Requisitos Licencias</a></li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div class="col-lg-3 col-md-6">
                    <div class="single-widget-wrap">
                        <h3 class="widget-title">HATUN QOSQO</h3>
                        <div class="widget-body">
                            <div class="newsletter-widget-wrap">
                                <p>Programa cultural del patrimonio inmaterial del Cusco.</p>
                                <a href="https://www.youtube.com/channel/UCPaMQnyHK8r6LMt5Ml8nR2w" class="btn btn-danger" style="background-color: #821644; border-color: #821644; color: white;" target="_blank"><i class="fa fa-play"></i> Hatun Qosqo</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="footer-bottom-area">
        <div class="container">
            <div class="row align-items-center">
                <div class="col-md-6 col-sm-7 order-last">
                    <div class="footer-copyright-area mt-xs-10 text-center text-sm-left">
                        <p>Componente Sistemas/GIS -2021 © Gerencia de Centro Histórico</p>
                    </div>
                </div>
                <div class="col-md-6 col-sm-5 order-first order-sm-last">
                    <div class="footer-social-icons nav justify-content-center justify-content-md-end">
                        <a href="https://www.facebook.com/gerenciacentrohistoricocusco" target="_blank" class="trio-tooltip" data-tippy-content="Facebook"><i class="fa fa-facebook"></i></a>
                        <a href="https://www.youtube.com/channel/UCPaMQnyHK8r6LMt5Ml8nR2w" target="_blank" class="trio-tooltip" data-tippy-content="Youtube"><i class="fa fa-youtube"></i></a>
                        <a href="https://www.instagram.com/gerenciadecentrohistorico/" target="_blank" class="trio-tooltip" data-tippy-content="Instagram"><i class="fa fa-instagram"></i></a>
                    </div>
                </div>
            </div>
        </div>
    </div><!-- End Footer Bottom Area -->
</footer>
